<template>
  <!-- 出库单费项列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">

<!--        <el-button plain-->
<!--                   class="glo_btnItems glo_bgcMainColor"-->
<!--                   @click="withhold"-->

<!--        >取消发货</el-button-->
<!--        >-->
<!--        v-if="hasPermiss('admin:delivery:hold:waybill')"-->

        <el-button
            v-if="hasPermiss('yfgl_yingFuDaoRu:import:fee')"
            class="glo_btnItems "
            @click="importFee"
        >导入费用</el-button
        >
        <el-button
            v-if="hasPermiss('yfgl_yingFuDaoRu:examine')"
            class="glo_btnItems "
            @click="toExamine"
        >审核</el-button
        >
        <el-button
            v-if="hasPermiss('yfgl_yingFuDaoRu:examine:return')"
            class="glo_btnItems "
            @click="CancelApproval"
        >返审核</el-button
        >
        <el-button
            v-if="hasPermiss('yfgl_fuKuanHeXiao:writeoff')"
            class="glo_btnItems "
            @click="applyS"
        >批量核销</el-button
        >
        <el-button
            v-if="hasPermiss('yfgl_fuKuanHeXiao:writeoff')"
            class="glo_btnItems "
            @click="apply"
        >单笔核销</el-button
        >
        <el-button class="glo_btnItems " @click="CancelPayment"
        >返核销</el-button
        >
        <el-button class="jy-button " @click="myModel"
        >表格设置</el-button
        >
        <template >
          <div class="tableExportBtn">
            <exportTb
                :theadData="myTableHeard"
                :tableData="tableData"
                :resultData="tableData"
                @handleExportDia_dc="handleExportDia_dc('出库单费项列表')"
            ></exportTb>
          </div>
        </template>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field === 'aaaaaaaaaa' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel">
                {{ scope.row.aaaaaaaaaa }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>

      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!--        自定义表头           -->
    <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
    ></sorttable>

    <!-- 导出插件 -->
    <exportComponent
        :isShowDialog_dc="exportForm.isShowDialog_dc"
        :diaWidth_dc="exportForm.diaWidth_dc"
        :diaHeight_dc="exportForm.diaHeight_dc"
        :dialogTitle="exportForm.dialogTitle"
        :dialogForm_dc="exportForm.dialogForm_dc"
        :data="exportForm.queryForm"
        :tableHeard="exportForm.EPtableHeard"
        :AllCheck="exportForm.EPAllCheck"
        @checktabEP="checktabEP"
        @checkAllEP="checkAllEP"
        @onAfterEnter="onAfterEnter"
        @handleCloseDia_dc="handleCloseDia_dc"
        @diaConfirmBtn_dc="diaConfirmBtn_dc"
        queryType="exportModeList"
    >
    </exportComponent>

    <!-- 核销返核销 -->
    <el-dialog
        :title="hexiaoTitle"
        :visible.sync="paymentBox"
        @close="fukuanClose"
    >
      <div class="newForm">
        <el-form
            :model="paymentArray"
            :rules="rules"
            ref="paymentArray"
            label-width="120px"
        >
          <div class="queryItem1">
            <el-form-item label="收款金额:">
              <el-input
                  v-model="TotalAmount"
                  :disabled="DiaType == 'applyS' || DiaType == 'CancelPayment'"
              ></el-input>
            </el-form-item>
          </div>
          <div
              class="queryItem1"
              v-if="DiaType == 'applyS' || DiaType == 'CancelPayment'"
          >
            <el-form-item label="付款票数:">
              <el-input
                  v-model="TotalNumber"
                  readonly
                  :disabled="DiaType == 'applyS'"
              ></el-input>
            </el-form-item>
          </div>
          <div class="queryItem1" v-if="DiaType !== 'CancelPayment'">
            <el-form-item label="资金账号:" prop="zjAccount">
              <el-select
                  filterable
                  clearable
                  placeholder="请选择"
                  v-model="paymentArray.zjAccount"
                  @change="changeACCount"
              >
                <el-option
                    v-for="itme in zijingList"
                    :key="itme.accountId"
                    :label="itme.accountName"
                    :value="itme.accountId"
                >
                  {{ itme.accountName + "(" + itme.account + ")" }}
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="queryItem1" v-if="DiaType !== 'CancelPayment'">
            <el-form-item label="收款人:">
              <el-input v-model="paymentArray.payee"></el-input>
            </el-form-item>
          </div>
          <div class="queryItem1">
            <el-form-item label="核销时间" prop="writeOffTime">
              <el-date-picker
                  style="width: 100%"
                  class="input"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="paymentArray.writeOffTime"
                  type="datetime"
                  placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="queryItem1" v-if="DiaType !== 'CancelPayment'">
            <el-form-item label="核销备注:">
              <el-input
                  type="textarea"
                  rows="3"
                  v-model="paymentArray.writeoffComment"
              ></el-input>
            </el-form-item>
          </div>

          <el-form-item style="margin-top: 20px" label="上传图片">
            <el-upload
                :action="uploadUrl"
                :http-request="uploadSectionImg"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :file-list="fileListImg"
                :limit="fileNum"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
        </el-form>
      </div>
      <div class="footerbox">
        <el-button class="seniorbut" @click="PaymentConfirmation"
        >确认</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
        title="上传编辑好的导出模板"
        :visible.sync="show_upload"
        append-to-body
        width="40%"
        center
    >
      <div>
        <el-upload
            :action="uploadUrl"
            :show-file-list="true"
            :file-list="fileList"
            :limit="1"
            :http-request="uploadSectionFile"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">上传模板</div>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show_upload = false">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>
  <script>
  import tableListNew from "@/pages/tableListNew.js";
import tableList from "@/pages/DynamicList/tableList.js";
//   import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import utils from "@/assets/js/tool";
//   import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import { Api } from "@/assets/js/api";
import sorttable from "@/components/sortTemplate.vue";
import exportComponent from "@/components/exportComponent/index.vue";
  import exportTb from "@/components/exportComponent/exportTb.vue";
  import tools from "@/assets/js/tool";

export default {
  mixins: [tableList,tableListNew],
  inject: ["reload"],
  components: {
    exportTb,
    exportComponent, sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "出库单费项列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd===等待下载完成,bdd===不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "financeOutEntruckServiceList", //  页面标识
      reportFiledsNumber: "finance_out_entruck_service_list", // 动态 条件、表头

      currentItemArr: [],
      dataList: [],
      exportForm: {
        isShowDialog_dc: false,
        diaWidth_dc: "60%",
        dialogTitle_dc: "导出数据",
        dialogForm_dc: {
          pageStart: 1,
          pageTotal: "",
          fileName: "出库单费项列表",
          apiName: "/v1/common/query/runPageReport",
          EpType: "dd", //dd===等待下载完成,bdd===不等待完成
          apiType: "POST",
          isJson: 1,
        },
      },
      hexiaoTitle: "核销",
      paymentBox: false, //审核弹窗
      paymentArray: {
        financeOutids: [], //应付计费id数组
        isWriteoff: 1, //核销参数(0=返核销,1=核销)
        zjAccount: "", //资金账户id
        collectionAccount: "", //收款账号
        payee: "", //收款人
        receivingBank: "", //收款银行
        storageId: "", //仓库ID
        writeoffComment: "", //备注
        writeOffTime: "", //
        writeOffPic: [],
      },
      TotalAmount: "", //金额
      show_upload: false, //显示上传弹窗
      uploadUrl: "", //上传路径
      fileList: [],
      fileListImg: [], //核销图片
      fileNum: 6,
      dialogVisible: false, //
      dialogImageUrl: "",
      rules: {
        zjAccount: [
          { required: true, message: "请选择资金账户", trigger: "change" },
        ],
        writeOffTime: [
          { required: true, message: "请选择核销时间", trigger: "change" },
        ],
      },
      DiaType: "",
      TotalNumber: 0,
      zijingList: [], //资金账号下拉列表
    };
  },
  watch: {
    //监听this.tableData 当数据中isImportAmount=1 并且settlementAmount 不等于importAmount时 把所在表格中的行背景色变成红色

  },
  created() {
    this.uploadUrl = this.common.uploadUrl;
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 表格行的类名方法
    tableRowClassName({ row, rowIndex }) {
      // 当数据中isImportAmount=1 并且settlementAmount 不等于importAmount时，返回红色样式类
      if (row.isImportAmount === 1 && row.settlementAmount !== row.importAmount) {
        return 'red-row';
      }
      return '';
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
    },

    async toExamine(){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择审核费项",
          type: "warning",
        });
        return false;
      }
      let ids = this.currentItemArr.map((item) => {
        return item.billServiceItemId;
      });

      let obj = {
        billItemServiceTableIds: ids,
      };
      await Api.examFinanceOutService(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
            if("success"===data.status){
              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            }
          }
        }
      });


    },
    async CancelApproval(){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择反审核费项",
          type: "warning",
        });
        return false;
      }
      let ids = this.currentItemArr.map((item) => {
        return item.billServiceItemId;
      });

      let obj = {
        billItemServiceTableIds: ids,
      };
      await Api.cancelExamFinanceOutService(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
            if("success"===data.status){
              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            }
          }
        }
      });


    },
    //单笔核销
    apply() {
      this.DiaType = "apply";
      this.hexiaoTitle = "付款核销";
      let currentItemArr = this.currentItemArr;
      if (currentItemArr.length > 1) {
        this.$message.warning("多条数据请选择批量核销");
        return;
      }
      if (currentItemArr.length < 1) {
        this.$message.warning("请勾选一条数据");
      } else {
        let financeOutids = [];
        let money = [];
        for (var i = 0; i < currentItemArr.length; i++) {
          if (
              currentItemArr[i].writeoffStatus === "yi_he_xiao:writeoff_status"
          ) {
            this.$message.warning("选项中存在已核销项,不能进行核销");
            return;
          }
          if(!currentItemArr[i].financeId){
            this.$message.warning("选项中存在未审核项,不能进行核销");
            return;
          }
          console.info("对比",Number(currentItemArr[i].settlementAmount))
          console.info("对比",Number(currentItemArr[i].importAmount))
          if(currentItemArr[i].isImportAmount === 1 && Number(currentItemArr[i].settlementAmount) !== Number(currentItemArr[i].importAmount)){
            this.$message.warning("选项中存在结算金额 和 对账金额不一致, 暂不能核销");
            return;
          }
          money.push(Number(currentItemArr[i].unwriteoffAmount));
          financeOutids.push(Number(currentItemArr[i].financeId));
        }
        Api.capitalAccountList().then((res) => {
          this.zijingList = res.data.result || [];
        });
        this.paymentArray.financeOutids = financeOutids;
        this.paymentBox = true;
        let TotalAmount = this.sum(money);
        this.TotalAmount = TotalAmount;
      }
    },
    sum(arr) {
      var s = 0;
      for (var i = arr.length - 1; i >= 0; i--) {
        s = tools.add(s, arr[i]);
      }
      return tools.mathToFixed(s, 2);
    },
    //批量核销
    applyS() {
      this.DiaType = "applyS";
      this.hexiaoTitle = "付款核销";
      let currentItemArr = this.currentItemArr;
      if (currentItemArr.length < 1) {
        this.$message.warning("请至少勾选一条数据");
      } else {
        let financeOutids = [];
        let money = [];
        for (var i = 0; i < currentItemArr.length; i++) {
          if (
              currentItemArr[i].writeoffStatus === "yi_he_xiao:writeoff_status"
          ) {
            this.$message.warning("选项中存在已核销项,不能进行核销");
            return;
          }
          if(!currentItemArr[i].financeId){
            this.$message.warning("选项中存在未审核项,不能进行核销");
            return;
          }
          if(currentItemArr[i].isImportAmount === 1 && Number(currentItemArr[i].settlementAmount) !== Number(currentItemArr[i].importAmount)){
            this.$message.warning("选项中存在结算金额 和 对账金额不一致, 暂不能核销");
            return;
          }
          money.push(Number(currentItemArr[i].unwriteoffAmount));
          financeOutids.push(Number(currentItemArr[i].financeId));
        }

        Api.capitalAccountList().then((res) => {
          this.zijingList = res.data.result || [];
        });
        this.paymentArray.financeOutids = financeOutids;
        this.paymentBox = true;
        this.TotalNumber = money.length || 0;
        let TotalAmount = this.sum(money);
        this.TotalAmount = TotalAmount;
      }
    },
    //取消付款
    CancelPayment() {
      this.DiaType = "CancelPayment";
      this.hexiaoTitle = "返核销";
      let currentItemArr = this.currentItemArr;
      if (currentItemArr.length < 1) {
        this.$message.warning("请至少勾选一条数据");
      } else {
        for (var a = 0; a < currentItemArr.length; a++) {
          if (
              currentItemArr[a].writeoffStatus === "wei_he_xiao:writeoff_status"
          ) {
            this.$message.warning("已选数据中存在未核销数据");
            return;
          }
        }

        let financeOutids = [];
        let money = [];
        for (var i = 0; i < currentItemArr.length; i++) {
          money.push(Number(currentItemArr[i].writeoffAmount));
          financeOutids.push(Number(currentItemArr[i].financeId));
        }
        this.paymentArray.financeOutids = financeOutids;
        this.paymentBox = true;
        this.TotalNumber = money.length || 0;
        let TotalAmount = this.sum(money);
        this.TotalAmount = TotalAmount;
      }
    },
    //付款弹窗关闭
    fukuanClose() {
      this.paymentBox = false;
      this.TotalAmount = "";
      this.fileListImg = [];
      this.paymentArray = {
        financeOutids: [], //应付计费id数组
        isWriteoff: 1, //核销参数(0=返核销,1=核销)
        zjAccount: "", //资金账户id
        collectionAccount: "", //收款账号
        payee: "", //收款人
        receivingBank: "", //收款银行
        storageId: "", //仓库ID
        writeOffTime: "", //
        writeOffPic: [],
      };
    },

    //上传图片
    uploadSectionImg(param) {
      ////console.log(param);
      const file = param.file,
          fileName = file.name;

      // 根据后台需求数据格式
      const form = new FormData();
      // 文件对象
      form.append("file", file);
      // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
      form.append("fileName", fileName);
      let signArr = [
        {
          key: "fileName",
          val: fileName,
        },
      ];
      let sign = tools.getMD5Sign(signArr);
      form.append("sign", sign);
      // 项目封装的请求方法，下面做简单介绍
      Api.uploadFile(form)
          .then((res) => {
            if (res.data.status == "success") {
              // let fileDatas = res.data.result || '';
              let fileName = res.data.result.fileName;
              this.paymentArray.writeOffPic.push(fileName);
              // console.log(res);
            }
          })
          .catch((err) => {});
    },
    // 删除图片
    handleRemove(flie, fileList) {
      this.paymentArray.writeOffPic = fileName;
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    changeACCount(e) {
      console.log(e);
      let acounts = "";
      this.zijingList.forEach((item, index) => {
        if (item.accountId == e) {
          acounts = item.accountName;
        }
      });
      this.paymentArray.collectionAccount = acounts;
    },
    //核销确认
    PaymentConfirmation() {
      let _this = this;
      this.$refs.paymentArray.validate((valid) => {
        if (valid == false) {
          return;
        } else {
          // let paymentArray = this.paymentArray;
          let singleWriteoff = 0; //0=批量核销,1=单次核销
          if (this.DiaType == "CancelPayment") {
            this.paymentArray.isWriteoff = 0;
          } else {
            this.paymentArray.isWriteoff = 1;
            if (this.DiaType == "apply") {
              singleWriteoff = 1;
            }
          }
          let param = {
            financeOutids: this.paymentArray.financeOutids || [],
            isWriteoff: this.paymentArray.isWriteoff,
            payMoney: this.TotalAmount || 0,
            payee: this.paymentArray.payee,
            singleWriteoff: singleWriteoff,
            storageId: this.paymentArray.storageId,
            writeoffComment: this.paymentArray.writeoffComment,
            zjAccount: this.paymentArray.zjAccount,
            writeOffTime: this.paymentArray.writeOffTime, //
            writeOffPic: this.paymentArray.writeOffPic || [],
          };
          Api.financeOutWriteoff(param).then((res) => {
            if (res.data.status == "success") {
              _this.$message.success(res.data.message || "操作成功");
            }
            _this.paymentBox = false;
            _this.getData();
          });
        }
      });
    },
    //应付申请
    importFee() {
      this.$router.push("/pages/v4/finance/importFinanceOutItemServiceFee?pageType=add");
    },
    // 不能输入负数
    minNum(val) {
      return val < 0 ? 0 : val;
    },
  }

};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}
.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
  }
}
::v-deep .el-date-editor.el-input {
  width: auto !important;
}

// 添加红色行的样式
::v-deep .red-row {
  background-color: #f56c6c !important; // 红色背景
  color: #fff; // 白色文字以提高可读性
}

.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
  }
}

</style>
  